// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"Z0-z"};